export enum GuiButtonStyle {
    BUTTON = 1,
    CHECKBOX,
    RADIO

    //TODO investigate 4 and 5, see https://www.blitzforum.de/help/CreateButton
}
